import { Box, Tabs, Tab } from "@mui/material";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useStore } from "src/Shared/Hooks";
import { observer } from "mobx-react";

const SettingTabs: React.FC = () => {
  const location = useLocation();
  const activeTab = location.pathname.split("/")[2];
  const {
    rootStore: { authStore },
  } = useStore();

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs variant="fullWidth" value={activeTab}>
          <Tab
            value={"lead-types"}
            sx={{ width: "100%" }}
            label="Lead Types"
            component={Link}
            to={`lead-types`}
          />
          {authStore.isGranted("CRM.UserManagement") && (
            <Tab
              value={"user-management"}
              sx={{ width: "100%" }}
              label="User Management"
              component={Link}
              to={`user-management`}
            />
          )}
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
};

export default observer(SettingTabs);

